import { z } from 'zod';

export const MaterialScalarFieldEnumSchema = z.enum(['materialId','cityId','caseId','qtyMaterial','details','unitMaterial','unitCostMaterial','vendorMaterial','typeMaterial','dateMaterial','materialCost']);

export default MaterialScalarFieldEnumSchema;
